function isMobile() {
  return $("#isMobile").css("display") == "none";
}

// LazyLoad
var lazyLoadInstance = new LazyLoad({
  elements_selector: ".img-lazy"
});

// cov19 banner
$(() => {
  $(".cov19banner-close").on("click", () => {
    $(".cov19banner").hide();
    document.cookie = "cov19banner=1";
  });

  $(".cov19banner-head-text").on("click", () => {
    if ($(".cov19banner").hasClass("active"))
      $(".cov19banner").removeClass("active");
    else $(".cov19banner").addClass("active");
  });
});

// cookie banner
$(() => {
  $(".cookie-banner-button").on("click", () => {
    $(".cookie-banner").hide();
    document.cookie = "cookieBanner=1;path=/";
    if ($("#treeElement").length > 0) {
      $("#treeElement").addClass("cookieDone");
    }
  });

  if ($(".mobile-buttons").is(":visible") && isMobile()) {
    $(".cookie-banner").addClass("cookie-banner-up");
  }

  if (
    $(".forward-button-container").css("position") === "fixed" &&
    isMobile()
  ) {
    $(".cookie-banner").addClass("cookie-banner-up");
  }
});

// Data href
$(() => {
  $("[data-href]").on("click", function () {
    window.location.href = $(this).attr("data-href");
  });
});

// Data trim
$(() => {
  $(document).on("change", ".data-trim", function () {
    const val = $(this).val().trim();
    $(this).val(val);
  });
});

// Handle header navbar toggle
$(() => {
  // closeMobileHeader
  $("#closeMobileHeader").on("click", function () {
    $(".navbar-collapse").removeClass("show");
    $("html").css("overflow-y", "visible");
    $("body").css("overflow-y", "visible");
  });

  // navbar-toggler
  $(".navbar-toggler").on("click", function () {
    $("html").css("overflow-y", "hidden");
    $("body").css("overflow-y", "hidden");
  });

  // navbar-collapse
  $('.navbar-collapse').on('hidden.bs.collapse', function () {
    $("html").css("overflow-y", "visible");
    $("body").css("overflow-y", "visible");
  })
});

$("body").on("scroll", function() {
  let threshold = 67;
  if($(".cov19banner").is(":visible")) threshold += 24;
  if ($(this).scrollTop() > threshold) {
    $('.following-header-element .navbar').show();
  } else {
    $('.following-header-element .navbar').hide();
  }
});